import { post, get, put, deleteApi } from './axiosFun';

// 角色分页
export const rolePage = (params) => { return post("/sys/sys-role/rolePage", params) };

// 角色列表
export const roleList = (params) => { return post("/sys/sys-role/roleList", params) };
//角色新增
export const roleAdd = (params) => { return post("/sys/sys-role/roleAdd", params) };
//角色编辑
export const roleEdit = (params) => { return post("/sys/sys-role/roleEdit", params) };
//角色删除
export const roleRemove = (params) => { return post("/sys/sys-role/roleRemove", params) };
//查询角色菜单树以及是否选中
export const roleMenuTree = (roleId) => { return get(`/sys/sys-role-menu/roleMenuTree/${roleId}`) };

//PC端角色菜单分配
export const roleMenuAssign = (params) => { return post(`/sys/sys-role-menu/roleMenuAssign`,params) };

//查询角色选中的菜单列表
export const roleMenuSelectList = (roleId) => { return get(`/sys/sys-role-menu/roleMenuSelectList/${roleId}`) };


//查询角色选中的菜单树
export const roleMenuSelectTree = (roleId) => { return get(`/sys/sys-role-menu/roleMenuSelectTree/${roleId}`) };



// WEBPACK FOOTER //
// ./src/api/roleMG.js